



















import { Component, Vue, Emit } from 'vue-property-decorator'
import { QueryExpressCompanyList , UpdateExpressOrder,QueryOrderGoodsDescList} from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VTable } from '@/components/table'
import { TableHander } from '@/components/table'
import { PriceFormat } from '@/utils/tyepconvert'

@Component({
  components: { VTable }
})
export default class UpdateShippedDialog extends Vue {
  private show = false
  private orderCode = ""
  private formData: any = {
    // 变量需要换下
    companyCode: undefined,
    expressCode: undefined,
    orderCode: undefined,
    companyName: undefined,
    newCompanyCode: undefined,
    newCompanyName: undefined,
    newExpressCode: undefined,
  }
  private expressCompanyData: Array<any> = []

  private requiredRule = {
    required: true,
    message: '不能为空',
    trigger: 'blur'
  }
  // element 表单校验
  // 变量名一致
  private rules = {
    newCompanyCode: [this.requiredRule],
    newExpressCode: [this.requiredRule]
  }

  private selectData = []
  private tableData = []


  @Emit('close')
  private close() {
    this.show = false;
    (this.$refs.form as ElForm).resetFields()
    this.tableData = []
  }

  public async open( data: any | null = {}, orderCode: string) {
    this.show = true
    // 打开弹窗时传过来的物流单数据
    this.orderCode = orderCode
    this.formData.id = data.id
    this.formData.expressCode = data.expressCode
    this.formData.companyCode = data.companyCode
    this.formData.newCompanyCode = data.companyCode
    this.formData.newExpressCode = data.expressCode

    // TODO 加载物流节点信息 需要更新接口
    QueryExpressCompanyList().then(res=>{
      this.expressCompanyData = res
    })


  }

  // 保存按钮
  public async save() {
    console.log(this.selectData)
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      //TODO. 根据输入的值进行参数封装和调用接口
      this.formData.orderCode = this.orderCode
       // 根据code查找对应的公司名称
      const selectedCompany = this.expressCompanyData.find(
        company => company.code === this.formData.newCompanyCode
      );
      this.formData.newCompanyName = selectedCompany.name
      console.log(this.formData)
      const param = {...this.formData}
      //TODO 修改新的接口
      UpdateExpressOrder(param).then(res=>{
        this.$message.success("修改成功")
        this.$emit("success")
        this.close()
      })
    })
  }

}
